/**
 *
 * @param {Number} entityID (Joint)
 * @param {Number} regionID (Joint)
 * @param {Boolean} thirdPartyFee
 * @param {String} status
 * @returns {Number}
 */
export const getPayoutModel = (entityID, regionID, thirdPartyFee, status, useFlatRate) => {
  const _3rdPartyStatuses = [
    "E6_",
    "E9L",
    "F1_",
    "F1A",
    "F1B",
    "F2_",
    "F2A",
    "F3_",
    "F4_",
    "F5_",
    "F6_",
    "F6A",
    "F6B",
    "F7_",
    "F8_",
  ];
  // third party fee box checked and claim in F status

  if (thirdPartyFee == 1 && _3rdPartyStatuses.includes(status?.substring(0, 3))) {
    return 3;
  }
  //astound
  if (entityID === 14) {
    return regionID === 56 ? 1 : 2;
  }

  return useFlatRate ? 2 : 1;
};
